<template lang="pug">
  div
    Row(style="margin-top: 10px")
      Col(:lg="activeCol(card.name == title)" :md="12" v-for="(card,key) in cardItems" :key="key")
        Card(:class="cardPointerClass(card.name == title)" v-on:click.native="clickedCard(card)")
          p(slot="title") {{card.name}}
          component(:is="card.cardComponent")
    Divider {{title}}
    Row(type="flex" justify="space-between")
        Col(:lg="2" :md="4" :sm="24")
                SearchChartBtn(searchBtnText="GO" searchBtnIcon="md-search")
        Col(:lg="22" :md="20" :sm="24")
            components(:is="dashboardQueryFilterStyle[$store.getters.getDashboardConfig.dashboardQueryFilter]"
                    :isWithGroupName="$store.getters.isAdmin"
                    :isWithServiceGroupName="true"
                    :isWithServerName="true"
                    :isWithOrigin="true"
                    :customTimeRangeOptions="this.timeRangeOptions"
                    :dateRangeLimit="this.dateRangeLimit"
                    :isWithEdgeName="$store.getters.isAdmin")
    Row(style="margin-top: 8px")
      Col(:lg="24" :md="24")
        component(:is="contentComponent" :direction="direction")
</template>
<script>
import DashboardQueryFilter2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilter3 from "@/components/DashboardQueryFilterV3";

import OverviewCard from "@/components/HomePage/OverviewCard";
import DataUsageCard from "@/components/HomePage/DataUsageCard";
import WebProtectionCard from "@/components/HomePage/WebProtectionCard";
import AccelerationCard from "@/components/HomePage/AccelerationCard";
import MonitoringCard from "@/components/HomePage/MonitoringCard";

import OverviewContent from "@/components/HomePage/OverviewContent";
import DataUsageContent from "@/components/HomePage/DataUsageContent";
import WebProtectionContent from "@/components/HomePage/WebProtectionContent";
import AccelerationContent from "@/components/HomePage/AccelerationContent";
import MonitoringContent from "@/components/HomePage/MonitoringContent";

import { getFormOptions } from "@/api/formoptions";
import { purgeCache } from "@/api/edges";
import bus from "@/libs/bus.js";

import DashboardQueryFilterV2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilterV3 from "@/components/DashboardQueryFilterV3";

import { getTimeRangeOptions } from "@/libs/utils";

export default {
    name: "HomePage",
    components: {
        OverviewCard,
        DataUsageCard,
        WebProtectionCard,
        AccelerationCard,
        MonitoringCard,
        OverviewContent,
        DataUsageContent,
        WebProtectionContent,
        AccelerationContent,
        MonitoringContent,
        SearchChartBtn: () => import("@/components/SearchChartBtn")
    },
    data() {
        return {
            dashboardQueryFilterStyle: {
                V2: DashboardQueryFilterV2,
                V3: DashboardQueryFilterV3
            },
            queryFilter: {},
            pathValue: "",
            multiClearCache: false,
            contentComponent: OverviewContent,
            title: "Overview",
            cardItems: [
                {
                    name: "Overview",
                    cardComponent: OverviewCard,
                    contentComponent: OverviewContent,
                    col: 8
                },
                {
                    name: "Data Usage",
                    cardComponent: DataUsageCard,
                    contentComponent: DataUsageContent,
                    col: 4
                },
                {
                    name: "Web Protection",
                    cardComponent: WebProtectionCard,
                    contentComponent: WebProtectionContent,
                    col: 4
                },
                {
                    name: "Acceleration",
                    cardComponent: AccelerationCard,
                    contentComponent: AccelerationContent,
                    col: 4
                },
                {
                    name: "Monitoring",
                    cardComponent: MonitoringCard,
                    contentComponent: MonitoringContent,
                    col: 4
                }
            ],
            selectedGroupNames: [],
            selectedDomains: [],
            selectedServiceGroups: [],
            selectedTimerange: "1",
            selectedOrigins: [],
            selectedEdgeNames: [],
            customTimeRange: [],
            direction: "horizontal",
            allGroupNames: [],
            userDomains: [],
            userServiceGroups: [],
            originOptions: [],
            datePickerOptions: {
                disabledDate(date) {
                    var daySec = 86400000;
                    return (
                        (date && date.valueOf() < Date.now() - daySec * 90) ||
                        (date && date.valueOf() > Date.now() + daySec * 1)
                    );
                }
            },
            userDomainReduce: [],
            originOptionReduce: [],
            // 依據requestSummary開放可挑選的時間清單選項
            dateRangeLimit: 90,
            timeRangeOptions: [],
        };
    },
    methods: {
        clearCacheAction() {
            if (this.pathValue == "") {
                this.pathValue = "*";
            }
            var purgeItems = this.selectedDomains.map(e => {
                return {
                    domain: e,
                    key: this.pathValue
                };
            });
            var vm = this;
            purgeCache(purgeItems)
                .then(function(response) {
                    vm.$Notice.success({
                        title: "Clear success",
                        desc: `${response.statusText}`
                    });
                    this.pathValue = "";
                })
                .catch(function(err) {
                    vm.$Notice.warning({
                        title: "Clear fail",
                        desc: `${err.message}`
                    });
                });
        },
        cardPointerClass(isActive) {
            return isActive ? "cardPointer cardPointer-active" : "cardPointer";
        },
        activeCol(active) {
            return active ? 8 : 4;
        },
        clickedCard(card) {
            // console.log(card);
            this.contentComponent = card.contentComponent;
            this.title = card.name;
        },
        async loadTimeSettings() {
            const { dateRangeLimit, timeRangeOptions } = await getTimeRangeOptions({ dateRangeKey: "requestSummary" });
            this.dateRangeLimit = dateRangeLimit;
            this.timeRangeOptions = timeRangeOptions;
        },
    },
    mounted() {
        getFormOptions(`groupnames`).then(res => {
            this.allGroupNames = res.data.options;
        });
        getFormOptions(`servicegroupnames?groupName=${this.$store.state.queryGroupName}`).then(res => {
            this.userServiceGroups = res.data.options;
        });
        getFormOptions(`servernames?groupName=${this.$store.state.queryGroupName}`).then(res => {
            this.userDomains = res.data.options;
            this.userDomainReduce = this.userDomains.slice(0, 30);
        });
        getFormOptions(`origins?groupName=${this.$store.state.queryGroupName}`).then(res => {
            this.originOptions = res.data.options;
            this.originOptionReduce = this.originOptions.slice(0, 30);
        });
    },
    computed: {
        timerangeOptions() {
            return [
                {
                    label: this.$i18n.t("home.last_5min"),
                    value: "0",
                    chartxAxesTimeUnit: "minute"
                },
                {
                    label: this.$i18n.t("home.last_hour"),
                    value: "1",
                    chartxAxesTimeUnit: "minute"
                },
                {
                    label: this.$i18n.t("home.last_day"),
                    value: "2",
                    chartxAxesTimeUnit: "hour"
                },
                {
                    label: this.$i18n.t("home.last_seven_day"),
                    value: "3",
                    chartxAxesTimeUnit: "day"
                },
                {
                    label: this.$i18n.t("home.custom"),
                    value: "4",
                    chartxAxesTimeUnit: "day"
                }
            ];
        },
    },
    created() {
        this.loadTimeSettings();
    },
};
</script>
<style lang="less" scoped>
.cardPointer {
    transform: scale(0.9);
    cursor: pointer;
    text-align: center;
    // height: 235px !important;
    margin: 6px 6px 0px 6px;
    background: #fff;
    color: black;
}
.cardPointer > .ivu-card-head > p {
    font-size: 21px;
    height: 21px;
    line-height: 21px;
}
.cardPointer > .ivu-card-body {
    padding: 0px;
}

.cardPointer-active {
    transform: scale(1);
    box-shadow: 5px 5px 10px 5px #dedfe0;
}

.cardPointer-active > .ivu-card-head > p {
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/RequestAnalyze.vue